import { render, staticRenderFns } from "./url-linked-files-field.vue?vue&type=template&id=46cf3bd6"
import script from "./url-linked-files-field.vue?vue&type=script&lang=js"
export * from "./url-linked-files-field.vue?vue&type=script&lang=js"
import style0 from "./url-linked-files-field.vue?vue&type=style&index=0&id=46cf3bd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports